if (!customElements.get('brg-option-value')) {
  customElements.define('brg-option-value', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const select = this.querySelector('select');
      const text = this.querySelector('.brg-option-text');
      if (!select || !text) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const sync = () => {
        text.textContent = select.selectedOptions[0]?.textContent.trim() || '';
        if (this.trigger) this.trigger.disabled = select.disabled;
      };
      select.addEventListener('change', sync, {signal});
      select.addEventListener('input', sync, {signal});
      this.observer = new MutationObserver(sync);
      this.observer.observe(select, {subtree:true, childList:true, characterData:true, attributes:true});
      sync();
      this.setAttribute('data-enhanced', '');
      if (!('showPopover' in HTMLElement.prototype)) return;
      const label = this.closest('.product-form__input').querySelector('label');
      const trigger = document.createElement('button');
      this.trigger = trigger;
      trigger.type = 'button';
      trigger.className = 'brg-option-trigger';
      trigger.id = select.id + '-trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      if (label) {
        label.id = select.id + '-label';
        label.htmlFor = trigger.id;
        text.id = select.id + '-value';
        text.removeAttribute('aria-hidden');
        trigger.setAttribute('aria-labelledby', label.id + ' ' + text.id);
      }
      trigger.append(text);
      this.append(trigger);
      const panel = document.createElement('div');
      this.panel = panel;
      panel.className = 'brg-option-menu';
      panel.id = select.id + '-menu';
      panel.setAttribute('popover', 'auto');
      panel.setAttribute('role', 'listbox');
      if (label) panel.setAttribute('aria-labelledby', label.id);
      trigger.setAttribute('aria-controls', panel.id);
      document.body.append(panel);
      const close = (focus = false) => {
        if (panel.matches(':popover-open')) panel.hidePopover();
        if (focus) trigger.focus();
      };
      const open = () => {
        if (panel.matches(':popover-open')) return close();
        panel.replaceChildren();
        [...select.options].forEach((option, index) => {
          const item = document.createElement('button');
          item.type = 'button';
          item.className = 'brg-option-choice';
          item.setAttribute('role', 'option');
          item.setAttribute('aria-selected', String(option.selected));
          item.textContent = option.textContent.trim();
          item.disabled = option.disabled;
          item.tabIndex = -1;
          item.addEventListener('click', () => {
            select.selectedIndex = index;
            select.dispatchEvent(new Event('change', {bubbles:true}));
            sync();
            close(true);
          });
          panel.append(item);
        });
        const rect = this.closest('.product-form__input').getBoundingClientRect();
        const width = Math.min(rect.width, innerWidth - 24);
        panel.style.width = width + 'px';
        panel.style.left = Math.max(12, Math.min(rect.left, innerWidth - width - 12)) + 'px';
        panel.showPopover();
        const below = innerHeight - rect.bottom - 12;
        const above = rect.top - 12;
        const down = below >= Math.min(panel.scrollHeight, 240) || below >= above;
        panel.style.maxHeight = Math.max(44, Math.min(320, down ? below - 6 : above - 6)) + 'px';
        panel.style.top = (down ? rect.bottom + 6 : Math.max(12, rect.top - panel.offsetHeight - 6)) + 'px';
        const active = panel.querySelector('[aria-selected="true"]:not(:disabled)') || panel.querySelector('button:not(:disabled)');
        active?.focus({preventScroll:true});
        active?.scrollIntoView({block:'nearest'});
      };
      trigger.addEventListener('click', open, {signal});
      trigger.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {event.preventDefault(); open();}
      }, {signal});
      panel.addEventListener('toggle', () => trigger.setAttribute('aria-expanded', String(panel.matches(':popover-open'))), {signal});
      panel.addEventListener('keydown', event => {
        const items = [...panel.querySelectorAll('button:not(:disabled)')];
        const index = items.indexOf(document.activeElement);
        let next;
        if (event.key === 'ArrowDown') next = (index + 1) % items.length;
        if (event.key === 'ArrowUp') next = (index - 1 + items.length) % items.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = items.length - 1;
        if (next !== undefined) {event.preventDefault(); items[next]?.focus();}
        if (event.key === 'Escape') {event.preventDefault(); close(true);}
        if (event.key === 'Tab') {close(true);}
      }, {signal});
      window.addEventListener('resize', () => close(), {signal});
      document.addEventListener('scroll', event => {
        if (!panel.contains(event.target)) close();
      }, {capture:true, signal});
      this.setAttribute('data-custom-menu', '');
      sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.panel?.remove();
      if (this.trigger) {
        const text = this.trigger.querySelector('.brg-option-text');
        if (text) this.append(text);
        this.trigger.remove();
      }
      this.controller = null;
      this.trigger = null;
      this.removeAttribute('data-custom-menu');
    }
  });
}
